<template>
  <div>
    <app-header></app-header>
    <div class="home mt-3 container">
      <div class="row justify-content-center">
        <div class="col-md-3">
          <router-link to="/project/new">
            <button class="btn btn-block mt-5 btn-lg btn-outline-primary">
              <a>New Project</a>
            </button>
          </router-link>
          <router-link to="/project/search">
          <button class="btn btn-block mt-5 btn-lg btn-outline-primary">
            <a>Find Project</a>
          </button>
          </router-link>
          <router-link to="/tribunal/list">
          <button class="btn btn-block mt-5 btn-lg btn-outline-primary">
            <a>Tribunals</a>
          </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Header from '../Header';

    export default {
        name: "Dashboard",
        components : {
          appHeader : Header
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue